import { render } from "./Brain.vue?vue&type=template&id=4663b6aa&ts=true"
import script from "./Brain.vue?vue&type=script&lang=ts"
export * from "./Brain.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/junyichen/AffaMed/hda-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__